import { LayoutGrid, List } from 'lucide-react'

export type IncidentView = 'kanban' | 'list'

interface ViewToggleProps {
  value: IncidentView
  onChange: (next: IncidentView) => void
}

export function ViewToggle({ value, onChange }: ViewToggleProps): JSX.Element {
  return (
    <div
      role="group"
      aria-label="Switch incident view"
      className="inline-flex rounded-lg bg-gray-100 p-1"
    >
      <button
        type="button"
        aria-pressed={value === 'kanban'}
        onClick={() => onChange('kanban')}
        className={`inline-flex items-center gap-2 rounded-md px-4 py-1.5 text-sm font-medium transition ${
          value === 'kanban'
            ? 'bg-brand-green text-white shadow-sm'
            : 'text-gray-600 hover:text-gray-900'
        }`}
      >
        <LayoutGrid className="h-4 w-4" aria-hidden="true" />
        Kanban
      </button>
      <button
        type="button"
        aria-pressed={value === 'list'}
        onClick={() => onChange('list')}
        className={`inline-flex items-center gap-2 rounded-md px-4 py-1.5 text-sm font-medium transition ${
          value === 'list'
            ? 'bg-brand-green text-white shadow-sm'
            : 'text-gray-600 hover:text-gray-900'
        }`}
      >
        <List className="h-4 w-4" aria-hidden="true" />
        List
      </button>
    </div>
  )
}
